import React from 'react';
import { shallowEqual } from 'react-redux';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import { InnerRender } from './InnerRender';
import { useResponsiveTable } from '../store';

const NoMemoGrouped = ({
  group,
  tableName,
}: {
  group: string;
  tableName?: string;
}) => {
  const { name } = useResponsiveTableContext(tableName);

  const groupedFilters = useResponsiveTable((global) => {
    const state = global.responsiveTableSlice[name];
    return state?.filters.filter((current) => current.group === group);
  }, shallowEqual);

  return <InnerRender tableName={tableName} filters={groupedFilters} />;
};

export const Grouped = React.memo(NoMemoGrouped);
